// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.max-with-percentage {
  max-width: var(--list-item-max-width);
}
@media (max-width: 480px) {
  .max-with-percentage {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/collapsible-row-list.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF;AACE;EAHF;IAII,eAAA;EAEF;AACF","sourcesContent":[".max-with-percentage {\n  max-width: var(--list-item-max-width);\n\n  @media (max-width: 480px) {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
